module.exports = __webpack_public_path__ + "img/test01-5.64c4d3fd.jpg";